export const START_HOUR = 10;
export const END_HOUR = 22;
export const STEPS = 30; // In Minutes